import { computed, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';
import { useSession } from '@seedkit/vue-administration-module/public';

export function useSeedkitLayouts() {
  const route = useRoute();
  const session = useSession();

  const layouts = {
    AuthLayout: defineAsyncComponent(async () => (await import('./auth-layout')).AuthLayout),
    DefaultLayout: defineAsyncComponent(async () => (await import('./default-layout')).DefaultLayout),
    EmptyLayout: defineAsyncComponent(async () => (await import('./empty-layout')).EmptyLayout),
  };

  const layout = computed(() => {
    const isAuthenticated = !session.isAccessTokenEmpty && !session.isTokenExpired;

    return route.meta.layout
      ? layouts[ route.meta.layout as keyof typeof layouts ]
      : isAuthenticated
        ? layouts.DefaultLayout
        : !route.meta.guard
          ? layouts.DefaultLayout
          : layouts.AuthLayout;
  });

  return {
    list: layouts,
    current: layout,
  };
}
